import {createRecipe} from './recipe.js';

export const RecipeTrustKind=Object.freeze({
  OFFICIAL_CONTROLLED:'official_controlled',
  COMMUNITY_UNVERIFIED:'community_unverified',
  PRIVATE_PERSONAL:'private_personal'
});

const KNOWLEDGE_ID=/^[a-z][a-z0-9_]{2,79}$/;
const HTTPS=/^https:\/\//i;

function required(value,label,max=4000){
  const text=String(value??'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function optionalUrl(value){
  if(value==null||value==='')return null;
  const url=String(value).trim();
  if(!HTTPS.test(url))throw new TypeError('Controlled knowledge URL must use HTTPS');
  return url;
}

export function recipeTrustPresentation(recipe){
  const value=createRecipe(recipe);
  if(value.type==='official'){
    return Object.freeze({
      kind:RecipeTrustKind.OFFICIAL_CONTROLLED,
      label:'Oficjalna · treść kontrolowana',
      explanation:'Treść publikowana w kontrolowanym katalogu Dymistrza. Informacje bezpieczeństwa są oznaczane osobno i wskazują kontrolowane źródło.',
      verifiedSafetyByType:false
    });
  }
  if(value.type==='community'){
    return Object.freeze({
      kind:RecipeTrustKind.COMMUNITY_UNVERIFIED,
      label:'Społeczność · treść użytkownika',
      explanation:'Receptura społecznościowa nie jest automatycznie zweryfikowaną poradą bezpieczeństwa żywności.',
      verifiedSafetyByType:false
    });
  }
  return Object.freeze({
    kind:RecipeTrustKind.PRIVATE_PERSONAL,
    label:'Prywatna · tylko Twoja',
    explanation:'Prywatna receptura jest osobistym szablonem procesu i nie stanowi zweryfikowanej porady bezpieczeństwa.',
    verifiedSafetyByType:false
  });
}

export function createControlledSafetyRule({
  code,
  title,
  text,
  knowledgeId,
  knowledgeVersion,
  referenceUrl=null
}={}){
  const ruleCode=required(code,'code',80).toLowerCase();
  if(!KNOWLEDGE_ID.test(ruleCode))throw new TypeError('Invalid safety rule code');
  const reference=required(knowledgeId,'knowledgeId',80).toLowerCase();
  if(!KNOWLEDGE_ID.test(reference))throw new TypeError('Invalid controlled knowledge id');
  const version=Number(knowledgeVersion);
  if(!Number.isInteger(version)||version<1)throw new TypeError('knowledgeVersion must be a positive integer');
  return Object.freeze({
    code:ruleCode,
    title:required(title,'title',160),
    text:required(text,'text',2000),
    reference:Object.freeze({
      knowledgeId:reference,
      version,
      url:optionalUrl(referenceUrl)
    }),
    controlled:true
  });
}

export function normaliseControlledSafetyRules(rules=[]){
  if(!Array.isArray(rules))throw new TypeError('safetyRules must be an array');
  const result=rules.map(createControlledSafetyRule);
  if(new Set(result.map(rule=>rule.code)).size!==result.length){
    throw new TypeError('Safety rule codes must be unique');
  }
  return Object.freeze(result);
}

export function recipeSourcePresentation(recipe){
  const value=createRecipe(recipe);
  const trust=recipeTrustPresentation(value);
  return Object.freeze({
    recipeId:value.id,
    recipeType:value.type,
    trustKind:trust.kind,
    trustLabel:trust.label,
    trustExplanation:trust.explanation,
    author:value.authorName||null,
    source:value.sourceName||null,
    sourceUrl:value.sourceUrl||null,
    version:value.version
  });
}
